import { getLocations } from 'core/service/locations/locations.service';
import { usePocQuery } from 'core/custom-hooks/use-poc-query.hook';
import { Location } from 'core/contexts/locations/location.model';
import { userLocationAssignmentKeys } from 'core/query-client/keys/user-location-assignment.keys';
import { useMemo } from 'react';

export interface L1Location {
    id: string;
    name: string;
}

/**
 * Deliberately not `useLocations`: that is being repointed at `GET /api/v1/locations/by_user`
 * (POC-21832), which would offer an admin only their own assigned subtrees when assigning locations
 * to somebody else. TDR-018 Decision 4 exempts Settings from location filtering.
 */
export const useL1LocationsQuery = () => {
    const { data, isLoading, isError } = usePocQuery<Location[]>({
        queryKey: userLocationAssignmentKeys.locationCatalog(),
        queryFn: getLocations,
    });

    // Only the roots: the assignment set is L1, so nested children are not selectable.
    const locations = useMemo<L1Location[]>(
        () => (data ?? []).map((location) => ({ id: location.id, name: location.name })),
        [data]
    );

    return { locations, isLoading, isError };
};
